import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Configuration } from '../../../app.constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.css']
})
export class GuideComponent implements OnInit {

  public iframe: any;

  constructor(public config:Configuration, public router:Router) { }
  ngOnInit() {
    // this.iframe = document.getElementById('guideiframe') as HTMLIFrameElement;
    // // console.log(this.iframe)
    // this.iframe.onload = this.changeLink;
    // this.iframe.nativeElement.contentDocument.onload
  }
  
  changeLink(frame){
    let url = frame.contentWindow.location.href;
    console.log(url)
    if(url.indexof('login')!=-1){
      this.router.navigate(['/login']);
    }
  }

}
